
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire37b7"];
var parcelRegister = parcelRequire.register;
parcelRegister("0wXBc", function(module, exports) {
$parcel$export(module.exports, "useForceRedirect", function () { return (parcelRequire("kBhWP")).useForceRedirect; });
$parcel$export(module.exports, "usePrevious", function () { return (parcelRequire("buHgC")).usePrevious; });
$parcel$export(module.exports, "useGoogleLoginHandler", function () { return (parcelRequire("5k5vC")).useGoogleLoginHandler; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return (parcelRequire("5k5vC")).useSocialLoginHandlers; });
$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return (parcelRequire("iiGfm")).useRecaptchaChallengeObserver; });
parcelRequire("kBhWP");
parcelRequire("ilSAr");
parcelRequire("buHgC");
parcelRequire("5k5vC");
parcelRequire("iiGfm");

});
parcelRegister("kBhWP", function(module, exports) {

$parcel$export(module.exports, "useForceRedirect", function () { return $b61d37644088eedf$export$20eacf679bc57a60; });

var $91i6m = parcelRequire("91i6m");

var $9uXJ3 = parcelRequire("9uXJ3");
const $b61d37644088eedf$export$20eacf679bc57a60 = ({ redirectTo: redirectTo })=>{
    const maybeHardRedirect = (0, $9uXJ3.useMaybeHardRedirect)();
    (0, $91i6m.useEffect)(()=>{
        if (redirectTo) try {
            const url = new URL(redirectTo);
            maybeHardRedirect(url.toString());
        } catch (e) {
        // invalid URL provided
        }
    }, [
        redirectTo,
        maybeHardRedirect
    ]);
};

});

parcelRegister("ilSAr", function(module, exports) {

var $91i6m = parcelRequire("91i6m");
const $a79f15c75a3c2974$export$820558710db2d9c6 = (callback)=>{
    // eslint-disable-next-line react-hooks/exhaustive-deps
    (0, $91i6m.useEffect)(()=>callback(), []);
};

});

parcelRegister("buHgC", function(module, exports) {

$parcel$export(module.exports, "usePrevious", function () { return $8a47e052c4eb17f1$export$5cae361ad82dce8b; });

var $91i6m = parcelRequire("91i6m");
function $8a47e052c4eb17f1$export$5cae361ad82dce8b(newValue) {
    const previousRef = (0, $91i6m.useRef)();
    (0, $91i6m.useEffect)(()=>{
        previousRef.current = newValue;
    });
    return previousRef.current;
}

});

parcelRegister("5k5vC", function(module, exports) {

$parcel$export(module.exports, "useGoogleLoginHandler", function () { return $73f38aab5cb7ff9b$export$c5e89b4acf71d8e2; });
$parcel$export(module.exports, "useSocialLoginHandlers", function () { return $73f38aab5cb7ff9b$export$3388df9a8c5125bf; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");

var $ccxRw = parcelRequire("ccxRw");
const $73f38aab5cb7ff9b$export$c5e89b4acf71d8e2 = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    return (0, $91i6m.useCallback)(()=>{
        analyticsClient.buttonClickedEvent(pageId, "googleLoginButton", {
            redirectType: redirectType
        });
        (0, $ccxRw.redirectToGoogleLogin)(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
};
const $73f38aab5cb7ff9b$export$3388df9a8c5125bf = ({ pageId: pageId, redirectType: redirectType, redirectParams: redirectParams })=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const handleSocialLogin = (0, $91i6m.useCallback)((redirectFn, buttonId)=>{
        analyticsClient.buttonClickedEvent(pageId, buttonId, {
            redirectType: redirectType
        });
        redirectFn(redirectParams);
    }, [
        analyticsClient,
        pageId,
        redirectType,
        redirectParams
    ]);
    const handleMicrosoftLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToMicrosoftLogin), "microsoftLoginButton"), [
        handleSocialLogin
    ]);
    const handleAppleLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToAppleLogin), "appleLoginButton"), [
        handleSocialLogin
    ]);
    const handleSlackLogin = (0, $91i6m.useCallback)(()=>handleSocialLogin((0, $ccxRw.redirectToSlackLogin), "slackLoginButton"), [
        handleSocialLogin
    ]);
    return {
        handleMicrosoftLogin: handleMicrosoftLogin,
        handleAppleLogin: handleAppleLogin,
        handleSlackLogin: handleSlackLogin
    };
};

});
parcelRegister("ccxRw", function(module, exports) {

$parcel$export(module.exports, "LoginType", function () { return $ea2e76527b472b38$export$7ecae1a0f094da22; });
$parcel$export(module.exports, "buildState", function () { return $ea2e76527b472b38$export$13c6022a038eeeb6; });
$parcel$export(module.exports, "redirectToGoogleLogin", function () { return $ea2e76527b472b38$export$d6e924a711e9e261; });
$parcel$export(module.exports, "redirectToMicrosoftLogin", function () { return $ea2e76527b472b38$export$a2375491e360a04f; });
$parcel$export(module.exports, "redirectToAppleLogin", function () { return $ea2e76527b472b38$export$be4d35cbb0c7d143; });
$parcel$export(module.exports, "isAppleHiddenEmail", function () { return $ea2e76527b472b38$export$3fed42f6cd70c2bc; });
$parcel$export(module.exports, "redirectToSlackLogin", function () { return $ea2e76527b472b38$export$bdab6d1697fcd9e9; });
$parcel$export(module.exports, "isGoogleLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$20fa47fc379f30f3; });
$parcel$export(module.exports, "isAppleLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$2fcd6c2fe8f717c4; });
$parcel$export(module.exports, "isMicrosoftLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$9c936482818cd3df; });
$parcel$export(module.exports, "isSlackLoginOutageAdvisoryEnabled", function () { return $ea2e76527b472b38$export$94fcb0c439ca8c06; });
/* eslint-disable max-params */ 
var $dBq8m = parcelRequire("dBq8m");

var $3u8pF = parcelRequire("3u8pF");

var $3H79M = parcelRequire("3H79M");

var $1HVXA = parcelRequire("1HVXA");
var $ea2e76527b472b38$export$7ecae1a0f094da22;
(function(LoginType) {
    LoginType["Apple"] = "appleLogin";
    LoginType["Slack"] = "slackLogin";
    LoginType["Microsoft"] = "microsoftLogin";
    LoginType["GoogleButton"] = "googleButton";
    LoginType["GoogleOneTap"] = "googleYolo";
    LoginType["SSO"] = "ssoLogin";
})($ea2e76527b472b38$export$7ecae1a0f094da22 || ($ea2e76527b472b38$export$7ecae1a0f094da22 = {}));
const $ea2e76527b472b38$export$13c6022a038eeeb6 = ({ location: location, csrfToken: csrfToken, source: source, loginType: loginType, anonymousId: anonymousId, userFlow: userFlow, recoveryOptions: recoveryOptions })=>(0, $3u8pF.Base64).encode(JSON.stringify({
        csrfToken: csrfToken,
        query: location.search || undefined,
        source: source,
        loginType: loginType,
        anonymousId: anonymousId,
        userFlow: userFlow,
        expects: recoveryOptions?.expectedEmail,
        recovery: recoveryOptions?.recoveryToken
    }));
const $ea2e76527b472b38$export$d6e924a711e9e261 = ({ location: location, source: source, recoveryOptions: recoveryOptions })=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search);
    const filteredParams = Object.fromEntries(Object.entries(searchParams).filter(([key])=>key !== "login_hint"));
    const { userFlow: userFlow } = filteredParams;
    const params = {
        ...filteredParams,
        prompt: "select_account",
        source: source,
        loginType: "googleButton",
        userFlow: userFlow,
        recovery: recoveryOptions?.recoveryToken
    };
    location.assign(`${location.protocol}//${location.host}/login/initiate/google?` + (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(params));
};
const $ea2e76527b472b38$var$redirectToSocialLoginInitiate = ({ location: location, source: source, recoveryOptions: recoveryOptions, loginType: loginType, loginHint: loginHint })=>{
    const initiateParams = {
        ...(0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).parse(location.search),
        loginType: loginType,
        source: source,
        recovery: recoveryOptions?.recoveryToken,
        prompt: "select_account",
        login_hint: loginHint
    };
    let initiateUriSuffix;
    switch(loginType){
        case "appleLogin":
            initiateUriSuffix = "apple";
            break;
        case "microsoftLogin":
            initiateUriSuffix = "microsoft";
            break;
        case "slackLogin":
            initiateUriSuffix = "slack";
            break;
    }
    location.assign(`${location.protocol}//${location.host}/login/initiate/${initiateUriSuffix}?` + (0, (/*@__PURE__*/$parcel$interopDefault($dBq8m))).stringify(initiateParams));
};
const $ea2e76527b472b38$export$a2375491e360a04f = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $ea2e76527b472b38$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "microsoftLogin",
        loginHint: email
    });
};
const $ea2e76527b472b38$export$be4d35cbb0c7d143 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions, email: email } = params;
    $ea2e76527b472b38$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "appleLogin",
        loginHint: email
    });
};
const $ea2e76527b472b38$export$3fed42f6cd70c2bc = (email)=>{
    if (!email) return false;
    // Hidden email as defined by <unique-alphanumeric-string>@privaterelay.appleid.com
    const hiddenEmailDomainIdentifier = "privaterelay.appleid.com";
    const [domain] = email.split("@").slice(-1);
    return domain === hiddenEmailDomainIdentifier;
};
const $ea2e76527b472b38$export$bdab6d1697fcd9e9 = (params)=>{
    const { location: location, source: source, recoveryOptions: recoveryOptions } = params;
    $ea2e76527b472b38$var$redirectToSocialLoginInitiate({
        location: location,
        source: source,
        recoveryOptions: recoveryOptions,
        loginType: "slackLogin",
        // Slack's OIDC implementation expects login_hint to be a JWT and blows up if it's not. If
        // Slack ever supports using an email as the login_hint (like other OIDC providers) then we
        // should remove this line.
        loginHint: undefined
    });
};
const $ea2e76527b472b38$export$20fa47fc379f30f3 = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).GOOGLE_LOGIN_OUTAGE_ADVISORY);
const $ea2e76527b472b38$export$2fcd6c2fe8f717c4 = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).APPLE_LOGIN_OUTAGE_ADVISORY);
const $ea2e76527b472b38$export$9c936482818cd3df = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).MICROSOFT_LOGIN_OUTAGE_ADVISORY);
const $ea2e76527b472b38$export$94fcb0c439ca8c06 = (dynamicConfigs)=>(0, $1HVXA.getBooleanDynamicConfigValueOrDefault)(dynamicConfigs, (0, $3H79M.AidFrontendDynamicConfig).SLACK_LOGIN_OUTAGE_ADVISORY);

});
parcelRegister("3u8pF", function(module, exports) {
(function(global1, factory) {
    module.exports = factory(global1);
})(typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : module.exports, function(global1) {
    "use strict";
    // existing version for noConflict()
    global1 = global1 || {};
    var _Base64 = global1.Base64;
    var version = "2.6.4";
    // constants
    var b64chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    var b64tab = function(bin) {
        var t = {};
        for(var i = 0, l = bin.length; i < l; i++)t[bin.charAt(i)] = i;
        return t;
    }(b64chars);
    var fromCharCode = String.fromCharCode;
    // encoder stuff
    var cb_utob = function(c) {
        if (c.length < 2) {
            var cc = c.charCodeAt(0);
            return cc < 0x80 ? c : cc < 0x800 ? fromCharCode(0xc0 | cc >>> 6) + fromCharCode(0x80 | cc & 0x3f) : fromCharCode(0xe0 | cc >>> 12 & 0x0f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        } else {
            var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
            return fromCharCode(0xf0 | cc >>> 18 & 0x07) + fromCharCode(0x80 | cc >>> 12 & 0x3f) + fromCharCode(0x80 | cc >>> 6 & 0x3f) + fromCharCode(0x80 | cc & 0x3f);
        }
    };
    var re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
    var utob = function(u) {
        return u.replace(re_utob, cb_utob);
    };
    var cb_encode = function(ccc) {
        var padlen = [
            0,
            2,
            1
        ][ccc.length % 3], ord = ccc.charCodeAt(0) << 16 | (ccc.length > 1 ? ccc.charCodeAt(1) : 0) << 8 | (ccc.length > 2 ? ccc.charCodeAt(2) : 0), chars = [
            b64chars.charAt(ord >>> 18),
            b64chars.charAt(ord >>> 12 & 63),
            padlen >= 2 ? "=" : b64chars.charAt(ord >>> 6 & 63),
            padlen >= 1 ? "=" : b64chars.charAt(ord & 63)
        ];
        return chars.join("");
    };
    var btoa = global1.btoa && typeof global1.btoa == "function" ? function(b) {
        return global1.btoa(b);
    } : function(b) {
        if (b.match(/[^\x00-\xFF]/)) throw new RangeError("The string contains invalid characters.");
        return b.replace(/[\s\S]{1,3}/g, cb_encode);
    };
    var _encode = function(u) {
        return btoa(utob(String(u)));
    };
    var mkUriSafe = function(b64) {
        return b64.replace(/[+\/]/g, function(m0) {
            return m0 == "+" ? "-" : "_";
        }).replace(/=/g, "");
    };
    var encode = function(u, urisafe) {
        return urisafe ? mkUriSafe(_encode(u)) : _encode(u);
    };
    var encodeURI = function(u) {
        return encode(u, true);
    };
    var fromUint8Array;
    if (global1.Uint8Array) fromUint8Array = function(a, urisafe) {
        // return btoa(fromCharCode.apply(null, a));
        var b64 = "";
        for(var i = 0, l = a.length; i < l; i += 3){
            var a0 = a[i], a1 = a[i + 1], a2 = a[i + 2];
            var ord = a0 << 16 | a1 << 8 | a2;
            b64 += b64chars.charAt(ord >>> 18) + b64chars.charAt(ord >>> 12 & 63) + (typeof a1 != "undefined" ? b64chars.charAt(ord >>> 6 & 63) : "=") + (typeof a2 != "undefined" ? b64chars.charAt(ord & 63) : "=");
        }
        return urisafe ? mkUriSafe(b64) : b64;
    };
    // decoder stuff
    var re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
    var cb_btou = function(cccc) {
        switch(cccc.length){
            case 4:
                var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
                return fromCharCode((offset >>> 10) + 0xD800) + fromCharCode((offset & 0x3FF) + 0xDC00);
            case 3:
                return fromCharCode((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
            default:
                return fromCharCode((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
        }
    };
    var btou = function(b) {
        return b.replace(re_btou, cb_btou);
    };
    var cb_decode = function(cccc) {
        var len = cccc.length, padlen = len % 4, n = (len > 0 ? b64tab[cccc.charAt(0)] << 18 : 0) | (len > 1 ? b64tab[cccc.charAt(1)] << 12 : 0) | (len > 2 ? b64tab[cccc.charAt(2)] << 6 : 0) | (len > 3 ? b64tab[cccc.charAt(3)] : 0), chars = [
            fromCharCode(n >>> 16),
            fromCharCode(n >>> 8 & 0xff),
            fromCharCode(n & 0xff)
        ];
        chars.length -= [
            0,
            0,
            2,
            1
        ][padlen];
        return chars.join("");
    };
    var _atob = global1.atob && typeof global1.atob == "function" ? function(a) {
        return global1.atob(a);
    } : function(a) {
        return a.replace(/\S{1,4}/g, cb_decode);
    };
    var atob = function(a) {
        return _atob(String(a).replace(/[^A-Za-z0-9\+\/]/g, ""));
    };
    var _decode = function(a) {
        return btou(_atob(a));
    };
    var _fromURI = function(a) {
        return String(a).replace(/[-_]/g, function(m0) {
            return m0 == "-" ? "+" : "/";
        }).replace(/[^A-Za-z0-9\+\/]/g, "");
    };
    var decode = function(a) {
        return _decode(_fromURI(a));
    };
    var toUint8Array;
    if (global1.Uint8Array) toUint8Array = function(a) {
        return Uint8Array.from(atob(_fromURI(a)), function(c) {
            return c.charCodeAt(0);
        });
    };
    var noConflict = function() {
        var Base641 = global1.Base64;
        global1.Base64 = _Base64;
        return Base641;
    };
    // export Base64
    global1.Base64 = {
        VERSION: version,
        atob: atob,
        btoa: btoa,
        fromBase64: decode,
        toBase64: encode,
        utob: utob,
        encode: encode,
        encodeURI: encodeURI,
        btou: btou,
        decode: decode,
        noConflict: noConflict,
        fromUint8Array: fromUint8Array,
        toUint8Array: toUint8Array
    };
    // if ES5 is available, make Base64.extendString() available
    if (typeof Object.defineProperty === "function") {
        var noEnum = function(v) {
            return {
                value: v,
                enumerable: false,
                writable: true,
                configurable: true
            };
        };
        global1.Base64.extendString = function() {
            Object.defineProperty(String.prototype, "fromBase64", noEnum(function() {
                return decode(this);
            }));
            Object.defineProperty(String.prototype, "toBase64", noEnum(function(urisafe) {
                return encode(this, urisafe);
            }));
            Object.defineProperty(String.prototype, "toBase64URI", noEnum(function() {
                return encode(this, true);
            }));
        };
    }
    //
    // export Base64 to the namespace
    //
    if (global1["Meteor"]) Base64 = global1.Base64;
    // module.exports and AMD are mutually exclusive.
    // module.exports has precedence.
    if (0, module.exports) module.exports.Base64 = global1.Base64;
    else if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([], function() {
        return global1.Base64;
    });
    // that's it!
    return {
        Base64: global1.Base64
    };
});

});



parcelRegister("iiGfm", function(module, exports) {

$parcel$export(module.exports, "useRecaptchaChallengeObserver", function () { return $e5421413c7fac630$export$4cc6b1f2fa5dc3f4; });

var $91i6m = parcelRequire("91i6m");

var $1V2cH = parcelRequire("1V2cH");
const $e5421413c7fac630$var$recaptchaIframeTitle = "recaptcha challenge";
const $e5421413c7fac630$export$4cc6b1f2fa5dc3f4 = (pageId)=>{
    const analyticsClient = (0, $1V2cH.useAnalyticsClient)();
    const bodyObserver = (0, $91i6m.useRef)();
    const attributeObserver = (0, $91i6m.useRef)();
    (0, $91i6m.useEffect)(()=>{
        /*
      To determine if user has been presented with a Google reCAPTCHA challenge, we need to listen to DOM events and check if an <iframe> was injected.
      Said <iframe> will have 'src' attribute containing 'google.com/recaptcha/api2/bframe'. Unfortunately, that is not enough
      because Google will inject the <iframe> even if they're not gonna show the challenge. So we attach another observer,
      looking for a change on the 'style' attribute of the outmost containing <div>. If style.target.visibility is 'visible',
      then we send analytics event.
    */ const outerContainerAttributeObserver = ()=>{
            return new MutationObserver((records)=>{
                const visibleEvent = Array.from(records).find((mutation)=>mutation.attributeName === "style" && mutation.target.style.visibility === "visible");
                if (visibleEvent) {
                    analyticsClient.trackingEvent({
                        page: pageId,
                        action: "challenge",
                        subject: "googleRecaptcha"
                    });
                    attributeObserver.current?.disconnect();
                }
            });
        };
        if (window.MutationObserver) {
            bodyObserver.current = new MutationObserver((records)=>{
                records.forEach((mutation)=>{
                    mutation.addedNodes.forEach((node)=>{
                        if (!(node instanceof Element)) return;
                        const recaptchaIframe = node.querySelector(`iframe[title*='${$e5421413c7fac630$var$recaptchaIframeTitle}']`);
                        if (recaptchaIframe) {
                            bodyObserver.current?.disconnect();
                            const recaptchaOuterDiv = recaptchaIframe.parentNode?.parentNode;
                            if (recaptchaOuterDiv) {
                                attributeObserver.current = outerContainerAttributeObserver();
                                attributeObserver.current?.observe(recaptchaOuterDiv, {
                                    attributes: true
                                });
                            }
                        }
                    });
                });
            });
            bodyObserver.current?.observe(window.document.body, {
                childList: true
            });
        }
        return ()=>{
            bodyObserver.current?.disconnect();
            attributeObserver.current?.disconnect();
        };
    }, [
        analyticsClient,
        pageId
    ]);
};

});



//# sourceMappingURL=ExpiredPasswordPage.ffabaa69.js.map
